import React from 'react'
import * as R from 'ramda'
import { t } from 'ttag'

import { Dropdown } from 'components/shared/Dropdown/Dropdown'
import { CheckIcon, Icon } from 'components/shared/Icon/Icon'
import { List } from 'components/shared/List/List'

import styles from './Accounts.module.scss'

export const Accounts = ({ activeAccount, accounts, onSwitchAccount }) => (
  <Dropdown.MenuItem className={styles.accounts}>
    <span className={styles.label}>{t`Accounts`}</span>
    <List className={styles.list} direction="column">
      {R.map(
        ({ id, name }) => (
          <List.Item key={id}>
            <Dropdown.Action
              className={styles.action}
              onClick={() => onSwitchAccount({ id })}
            >
              <span className={styles.name}>{name}</span>
              {R.equals(activeAccount, id) ? (
                <Icon className={styles.icon} icon={CheckIcon} size={20} />
              ) : null}
            </Dropdown.Action>
          </List.Item>
        ),
        accounts,
      )}
    </List>
  </Dropdown.MenuItem>
)
